import React from 'react';
import styled from 'styled-components';

export default styled(({ color, ...rest }) => <div {...rest} />)`
  min-height: 100vh;
  background: ${({ color }) => color || 'transparent'};

  & > div[role='group'] {
    min-height: 100vh;
    display: grid;
    grid-template-rows: 1fr auto;
    grid-template-columns: 100%;
    grid-template-areas:
      'body'
      'footer';
  }
`;
